import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AlertController } from '@ionic/angular';
import { AlertOptions, AlertButton } from '@ionic/core';
import { LanguageService } from './language.service';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class HandlerErrorService {
  public loginErrors: any;
  public componentErrors: any;
  public errorInComponent: {
    textError: string;
    haveError: boolean;
  };
  constructor(
    public http: HttpClient,
    private languageService: LanguageService,
    private alertCtrl: AlertController,
    private translateService: TranslateService
  ) {

    this.loginErrors = {
      400: {
        0: 'LOGIN-ERRORS-400',
        1: 'LOGIN-ERRORS-400',
        2: 'LOGIN-ERRORS-400'
      },
      401: {
        0: 'LOGIN-ERRORS-401'
      },
      404: {
        0: 'LOGIN-ERRORS-404',
        1: 'LOGIN-ERRORS-404'
      },
      429: {
        0: 'LOGIN-ERRORS-429'
      }
    };

    this.componentErrors = {
      403: {
        0: 'No tienes permisos para visualizar este contenido'
      }
    };
  }

  public haveErrorInComponent(error) {
    this.errorInComponent = {
      haveError: false,
      textError: ''
    };
    this.errorInComponent.textError = 'error';
    if (error.error.messages) this.errorInComponent.textError = this.componentErrors[error.status][error.error.messages[0].code];

    this.errorInComponent.haveError = true;

    return this.errorInComponent;
  }

  public async cmsError() {
    const alertButtons: AlertButton[] = [{
      text: await this.languageService.translate('CANCEL'),
      role: 'cancel'
    }];
    const alertOptions: AlertOptions = {
      header: await this.languageService.translate('CONFIGURATION-ERROR'),
      subHeader: await this.languageService.translate('WRONG-CMS-CONFIGURATION'),
      buttons: alertButtons
    };

    let alert = await this.alertCtrl.create(alertOptions);

    await alert.present();
  }

  /**
   * Maneja el error 429 extrayendo el tiempo (segundos, minutos, horas o días) del mensaje del backend si está disponible
   * @param error - El objeto de error de la respuesta HTTP
   * @returns Mensaje traducido con el tiempo dinámico o mensaje genérico
   */
  public async get429ErrorMessage(error: any): Promise<string> {
    // Verificar si hay un mensaje del backend en error.error.error
    const backendMessage = error?.error?.error;
    
    if (backendMessage && typeof backendMessage === 'string') {
      // Intentar extraer días: "X day(s)"
      const daysMatch = backendMessage.match(/(\d+)\s*day\(s\)/i);
      if (daysMatch && daysMatch[1]) {
        const days = daysMatch[1];
        return await firstValueFrom(
          this.translateService.get('LOGIN-ERRORS-429-LOCKED-DAYS', { days })
        );
      }
      
      // Intentar extraer horas: "X hour(s)"
      const hoursMatch = backendMessage.match(/(\d+)\s*hour\(s\)/i);
      if (hoursMatch && hoursMatch[1]) {
        const hours = hoursMatch[1];
        return await firstValueFrom(
          this.translateService.get('LOGIN-ERRORS-429-LOCKED-HOURS', { hours })
        );
      }
      
      // Intentar extraer minutos: "X minute(s)"
      const minutesMatch = backendMessage.match(/(\d+)\s*minute\(s\)/i);
      if (minutesMatch && minutesMatch[1]) {
        const minutes = minutesMatch[1];
        return await firstValueFrom(
          this.translateService.get('LOGIN-ERRORS-429-LOCKED-MINUTES', { minutes })
        );
      }
      
      // Intentar extraer segundos: "X second(s)"
      const secondsMatch = backendMessage.match(/(\d+)\s*second\(s\)/i);
      if (secondsMatch && secondsMatch[1]) {
        const seconds = secondsMatch[1];
        return await firstValueFrom(
          this.translateService.get('LOGIN-ERRORS-429-LOCKED-SECONDS', { seconds })
        );
      }
    }
    
    // Si no hay mensaje del backend o no se puede extraer el tiempo, usar mensaje genérico
    return await this.languageService.translate('LOGIN-ERRORS-429');
  }
}
